import ReactGA from "react-ga4";

const GA_TRACKING_ID = "G-JPMBFKE3WN"; // Substitua pelo seu ID de acompanhamento

export const initGA = () => {
  ReactGA.initialize(GA_TRACKING_ID);
};

export const logPageView = () => {
  ReactGA.send("pageview", { page_path: window.location.pathname });
};
